module.exports = __webpack_public_path__ + "img/certik-audit.24ad1bbb.png";